import { Link } from 'react-router';
import LegalLayout from './landing/LegalLayout';
import { usePlatformLegalInfo } from '../hooks/usePlatformLegalInfo';
import { CONTACT } from '../content/site';

function DataDeletion() {
  const info = usePlatformLegalInfo();
  const contactEmail = info.contactEmail || CONTACT.email;
  const mail = <a href={`mailto:${contactEmail}`}>{contactEmail}</a>;

  return (
    <LegalLayout
      title="Data deletion"
      description="How to ask EFSoft to delete the personal data it holds about you, and what happens after you ask."
      path="/data-deletion"
      lastUpdated="16 October 2026"
    >
      <p>
        To have your personal data deleted from EFSoft&apos;s systems, follow
        the steps below. The <Link to="/privacy-policy">privacy policy</Link>{' '}
        lists the data we hold.
      </p>

      <section>
        <h2>1. Send us your request</h2>
        <p>
          Email {mail} with your full name, the email address or phone number
          you used to contact us, and a sentence saying you want your personal
          data deleted.
        </p>
      </section>

      <section>
        <h2>2. We confirm it is you</h2>
        <p>
          We may ask you to confirm your identity, so that nobody else can
          delete your data.
        </p>
      </section>

      <section>
        <h2>3. We delete the data</h2>
        <p>
          We delete your data from our active systems, which can take up to
          30 days after we confirm your identity. We keep only what the law requires us to
          keep, for example invoices and accounting records, and we tell you
          what that is.
        </p>
      </section>

      <section>
        <h2>4. We let you know</h2>
        <p>We email you when the deletion is done.</p>
      </section>

      <section>
        <h2>Chat data in your browser</h2>
        <p>
          If you used the chat, your browser also holds a cookie called{' '}
          <code>senderId</code>. You can remove it yourself by clearing this
          site&apos;s cookies in your browser settings.
        </p>
      </section>

      <div className="legal-callout">
        <p>Questions about deleting your data? Email us at {mail}.</p>
      </div>
    </LegalLayout>
  );
}

export default DataDeletion;
